import { State, createEmptyTournament, TError } from './state'
import { User } from '@gd/storage'
import { Zone } from '@/model/Zone'
import { Tournament } from '@/model/Tournament'
import { ERROR_CODES } from '@/model/ErrorCodes'
import { ZoneSelection } from '@/model/ZoneSelection'
import { Balance } from '@/model/UserData'

/**
 * mutations: are the correct file to change the state in the vuex store.
 *
 * Recommended to read before using: https://vuex.vuejs.org/guide/mutations.html
 */
const mutations = {
  /**
   *
   * @param state
   * @param user
   */
  applyUser(state: State, user: User) {
    state.user = user
  },
  applyUserBalance(state: State, balance: Balance) {
    state.balance = balance
  },
  /**
   * TODO: Example - needs to be done
   * @param state
   * @param serverZones
   */
  applyZonesTeasers(state: State, serverZones: Array<ZoneSelection>) {
    // e.g. the UI is only interest in the Array<ZoneSelection> -object we migrate it here
    state.zoneTeasers = serverZones
  },
  applyAnnouncement(state: State, announcement: string) {
    state.announcement = announcement
  },
  applyZone(state: State, zone: Zone) {
    state.zone = zone
  },
  setActiveTournament(state: State, tId: string) {
    const t: Tournament | undefined = state.zone.tournaments.filter(
      (tournament: Tournament) => tournament.tournamentId === tId
    )[0]
    if (t) {
      state.tournament = t
    } else {
      throw { errorCode: ERROR_CODES.TOURNAMENT_NOT_EXISTS, tournamentId: tId }
    }
  },
  resetActiveTournament(state: State) {
    state.tournament = createEmptyTournament()
  },
  /**
   * Called after the registration/rejoin process - make sure the state of state.tournament is correct
   * @param state
   * @param tournamentId
   */
  joinTournament(state: State, tournamentId: string) {
    state.tournament.joined = true
    // clear games list
    state.tournament.games = []
  },
  // commit a new error will trigger sending a jslog of this error ( See watcher in App.vue )
  error(state: State, err: TError) {
    state.error = err
  },
  gameRulesLoaded(state: State, loaded: boolean) {
    state.gameRulesLoaded = loaded
  },
}

export { mutations }
